import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { makeStyles, Typography } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';

import {
  TIPO_HORARIO_NORMAL,
  TIPO_HORARIO_DOMINGO,
  STATUS_LOJA_FECHADA,
} from '../../utils';

const useStyles = makeStyles((theme) => ({
  text: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '400px',
  },
}));

function getTipoHorario(value) {
  switch (value) {
    case TIPO_HORARIO_NORMAL:
      return 'Normal';
    case TIPO_HORARIO_DOMINGO:
      return 'Domingo';
    default:
      return '-';
  }
}

const DescricaoField = (props) => {
  const classes = useStyles();

  const record = useRecordContext(props);
  const value = record
    ? record.record.status_loja !== STATUS_LOJA_FECHADA
      ? getTipoHorario(record.record.tipo_horario)
      : ''
    : '';

  return (
    <Tooltip title={value} placement="bottom" aria-label="add2">
      <Typography className={classes.text}>{value}</Typography>
    </Tooltip>
  );
};

export default DescricaoField;
